import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { HeaderText } from './HeaderText';
import { DateUtils } from '../../../../../utils';

export const HeaderDates = ({ dates }) => {
    const { t } = useTranslation();
    const format = t('calendar.dateFormatOneLiner');
    const formatDate = (date) => DateUtils.formatDate(date, format);

    const datesFormatted = dates.filter((date) => !!date).map(formatDate);

    const getElement = (date, idx) => {
        return (
            <React.Fragment key={`Header-Dates-frag-${idx}`}>
                <span className="odf-space-outer-right-xs">
                    <HeaderText text={date} />
                </span>
                {idx === 0 && datesFormatted.length > 1 && (
                    <span className="odf-space-outer-right-xs">-</span>
                )}
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            {datesFormatted && datesFormatted.length > 0 && (
                <span className="odf-display-inline-flex">
                    {datesFormatted.map((date, idx) => getElement(date, idx))}
                </span>
            )}
        </React.Fragment>
    );
};

HeaderDates.propTypes = {
    dates: PropTypes.arrayOf(Date),
};

HeaderDates.defaultProps = {
    dates: [],
};
